<div *ngIf="currentUser?.pick1">
  <progressbar class="progress" [value]="columnHeaders" [max]="7"></progressbar>
  <span *ngIf="(progressDoc$ | async) as bars">
    <progressbar class="progress" [value]="bars[currentUser.pick1]" [max]="7">
    </progressbar>
  </span>
</div>


// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/core/program-progress-bar.component.html